import React from 'react';
import { Icon } from './Icon.js';
export const IconPenWriting = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("line", { x1: "17", y1: "17", x2: "12", y2: "17", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", "data-color": "color-2" }),
        React.createElement("path", { d: "m3,17l1-5L12.414,3.586c.781-.781,2.047-.781,2.828,0l1.172,1.172c.781.781.781,2.047,0,2.828l-8.414,8.414-5,1Z", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" })));
};
//# sourceMappingURL=IconPenWriting.js.map